import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import {
  oatCookingTypeOptions,
  grainLengthOptions,
  oatVarietyOptions,
} from './constants'
import Select from 'react-select'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from '../../shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotAlpha } from 'context/Utilities'

const BrownRicePackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    GrainSize: item.GrainSize,
    OatType: item.OatType,
    CookingType: item.CookingType,
    OatVariety: item.OatVariety,
    GrainLength: item.GrainLength,
  })

  const temp = {
    value: item.OatVariety,
    label: item.OatVariety,
  }

  const contains = oatVarietyOptions.some(e => {
    return JSON.stringify(temp) === JSON.stringify(e)
  })

  if (contains) {
    packaging.OatVariety = item.OatVariety
  } else {
    packaging.OatVariety = 'Other'
    packaging.otherType = item.OatVariety
    item.otherType = item.OatVariety
    item.OatVariety = 'Other'
  }

  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const {
        category,
        subCategory,
        GrainSize,
        CookingType,
        OatVariety,
        GrainLength,
      } = item
      setPackaging({
        category,
        subCategory,
        GrainSize,
        CookingType,
        OatVariety,
        GrainLength,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Cooking Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatCookingTypeOptions}
          defaultValue={{
            label: packaging.CookingType,
            value: packaging.CookingType,
          }}
          name="CookingType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Rice Cooking Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="CookingType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>Grain Length {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={grainLengthOptions}
          defaultValue={{
            label: packaging.GrainLength,
            value: packaging.GrainLength,
          }}
          name="grainLength"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Grain Length'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="grainLength"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
      <Col xs={6}>
        <p>
          <strong>Variety {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={oatVarietyOptions}
          defaultValue={{
            label: packaging.OatVariety,
            value: packaging.OatVariety,
          }}
          name="OatVariety"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Rice Variety'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            setPackaging({
              ...packaging,
              OatVariety: value,
            })
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="OatVariety"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        {item?.OatVariety === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="otherType"
              placeholder={'Other Type'}
              defaultValue={item.otherType}
              control={methods.control}
              rules={{ required: true }}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="otherType"
                message={'Other type is required.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        )}
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'Grain Size'}
            defaultValue={packaging.GrainSize}
            control={methods.control}
            rules={{ required: true, maxLength: 15 }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={true}
          />
        </FormGroup>
      </Col>
    </Row>
  )
}

BrownRicePackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BrownRicePackageReview
